;(() => {
  const SKIP_LABEL = 'Skip and view results';

  const relocateFoodFinderSkipLink = (scope = document) => {
    const roots = scope instanceof Element && scope.matches('.nd-food-finder')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('.nd-food-finder') || []);

    roots.forEach((root) => {
      const skipControl = root.querySelector('[data-skip-email]');
      const emailField = root.querySelector('[name="email"]');
      const consentRow = root.querySelector('.nd-food-finder__consent-row');
      const targetElement = consentRow || emailField;
      if (!skipControl || !targetElement) return;

      skipControl.textContent = SKIP_LABEL;
      skipControl.classList.remove('button', 'button--secondary', 'nd-food-finder__secondary-button');
      skipControl.classList.add('nd-food-finder__skip-email-link');
      skipControl.setAttribute('aria-label', SKIP_LABEL);

      const wrap = root.querySelector('.nd-food-finder__skip-email-wrap') || document.createElement('p');
      wrap.className = 'nd-food-finder__skip-email-wrap';
      targetElement.insertAdjacentElement('afterend', wrap);
      wrap.appendChild(skipControl);
    });
  };

  const syncFoodFinderPuppyActivityRequirement = (scope = document) => {
    const roots = scope instanceof Element && scope.matches('.nd-food-finder')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('.nd-food-finder') || []);

    roots.forEach((root) => {
      const form = root.querySelector('[data-quiz-form]');
      if (!form) return;

      const isPuppy = form.querySelector('[name="age_group"][value="puppy"]')?.checked;
      const activityRadios = Array.from(form.querySelectorAll('[name="activity"]'));
      activityRadios.forEach((input, index) => {
        input.required = !isPuppy && index === 0;
      });
    });
  };

  const initFoodFinderTweaks = () => {
    relocateFoodFinderSkipLink();
    syncFoodFinderPuppyActivityRequirement();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFoodFinderTweaks);
  } else {
    initFoodFinderTweaks();
  }

  document.addEventListener('change', (event) => {
    if (event.target?.matches?.('[name="age_group"]')) {
      const root = event.target.closest('.nd-food-finder');
      if (root) syncFoodFinderPuppyActivityRequirement(root);
    }
  });

  document.addEventListener('click', (event) => {
    const submitButton = event.target?.closest?.('[data-submit-quiz]');
    const root = submitButton?.closest?.('.nd-food-finder');
    if (root) syncFoodFinderPuppyActivityRequirement(root);
  }, true);

  document.addEventListener('shopify:section:load', (event) => {
    relocateFoodFinderSkipLink(event.target);
    syncFoodFinderPuppyActivityRequirement(event.target);
  });
})();
